// Changing here remember to changeQR-code mask in
// apps/parkapp-core-web/src/features/parkingQrCode/constants/codeMask.ts
export const PARKING_CODE_REGEX = /^[A-Z]{3}-[A-Z0-9]{4}$/;
export const SPOT_NAME_REGEX = /^[A-Za-z0-9-]{1,8}$/;
export const isValidSpotName = (name) => SPOT_NAME_REGEX.test(name);
export const isValidSpotNameOrEmpty = (name) => name.length === 0 || isValidSpotName(name);
